import zenObservable from 'zen-observable';
export var Observable = zenObservable;
//# sourceMappingURL=zenObservable.js.map